import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = { class: "body2-text text-black text-truncate pa-0" };
const _hoisted_2 = { class: "pt-3" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_v_col = _resolveComponent("v-col");
    const _component_OrderDetailGoodsAndPaymentInfoBarogoTooltip = _resolveComponent("OrderDetailGoodsAndPaymentInfoBarogoTooltip");
    const _component_v_row = _resolveComponent("v-row");
    const _component_v_card_text = _resolveComponent("v-card-text");
    const _component_PayTypeWithAmount = _resolveComponent("PayTypeWithAmount");
    const _component_v_btn = _resolveComponent("v-btn");
    const _component_AdjustPaymentDialog = _resolveComponent("AdjustPaymentDialog");
    const _component_BillDialog = _resolveComponent("BillDialog");
    const _component_v_card = _resolveComponent("v-card");
    const _directive_ui_permission = _resolveDirective("ui-permission");
    return (_openBlock(), _createBlock(_component_v_card, {
        flat: "",
        tile: "",
        class: "pa-0"
    }, {
        default: _withCtx(() => [
            _createCommentVNode(" 상품명 "),
            _createVNode(_component_v_row, { "no-gutters": "" }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "body2-text brg-color-grey-600 pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'goods_name')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(_component_OrderDetailGoodsAndPaymentInfoBarogoTooltip, { order: _ctx.order }, null, 8 /* PROPS */, ["order"])
                            ])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }),
            _createCommentVNode(" 결제금액 "),
            _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-4"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "body2-text brg-color-grey-600 pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'order_amount')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_text, { class: "d-block body2-text text-black text-truncate pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.formattedAmount), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }),
            _createCommentVNode(" 결제방법 "),
            _createVNode(_component_v_row, {
                "no-gutters": "",
                class: "mt-4"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "4" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "body2-text brg-color-grey-600 pa-0" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'payment_type')), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, { cols: "8" }, {
                        default: _withCtx(() => [
                            _createVNode(_component_v_card, {
                                flat: "",
                                tile: ""
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_PayTypeWithAmount, { "pay-types": _ctx.payTypes }, null, 8 /* PROPS */, ["pay-types"]),
                                    _createElementVNode("div", _hoisted_2, [
                                        _createCommentVNode(" TODO: 결제 금액 유효성 검사 추가 이전에 임시 주석 "),
                                        _createCommentVNode(" v-if=\"false && policy.isAdjustPaymentShow\" "),
                                        _createCommentVNode(" 결제정보 변경 모달 "),
                                        (!_ctx.isHQ && _ctx.isAdjustPaymentShow)
                                            ? (_openBlock(), _createBlock(_component_AdjustPaymentDialog, {
                                                key: 0,
                                                order: _ctx.order
                                            }, {
                                                activator: _withCtx((props) => [
                                                    _withDirectives((_openBlock(), _createBlock(_component_v_btn, _mergeProps(props, {
                                                        class: "brg-btn width-fill btn-outlined-basic",
                                                        variant: "outlined",
                                                        height: "40"
                                                    }), {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'change_payment_type')), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)), [
                                                        [_directive_ui_permission, [_ctx.userPermission.P_EDIT_ORDER_AMOUNT]]
                                                    ])
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["order"]))
                                            : _createCommentVNode("v-if", true),
                                        (_ctx.isCardApproved)
                                            ? (_openBlock(), _createBlock(_component_BillDialog, {
                                                key: 1,
                                                "order-id": _ctx.order && _ctx.order.orderId
                                            }, {
                                                activator: _withCtx((props) => [
                                                    _createVNode(_component_v_btn, _mergeProps(props, {
                                                        class: "brg-btn width-fill btn-outlined-basic",
                                                        variant: "outlined",
                                                        height: "40"
                                                    }), {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(_ctx.$t(_ctx.lc + 'show_bill')), 1 /* TEXT */)
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["order-id"]))
                                            : _createCommentVNode("v-if", true)
                                    ])
                                ]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            })
        ]),
        _: 1 /* STABLE */
    }));
}
